import React from "react";
import "./styles/landing.css";

const Contact = (props) => {
  return (
    <div className="d-flex flex-column ">
      <div id="contact" className="py-2 flex-grow-0">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-0">
              <h2 className="display-6 fw-bold">BRING SAFETY THROUGH QUALITY</h2>
            </div>
          </div>

          <div className="row justify-content-center" >
            <div className="col-auto">
              <div className="social">
                <ul className="list-unstyled d-flex gap-0 mb-0">
                  <li>
                    <a href={props.data?.instagram || "#"} className="text-decoration-none">
                      <i className="fab fa-instagram fa-xl text-white"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data?.twitter || "#"} className="text-decoration-none">
                      <i className="fab fa-twitter fa-xl text-white"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data?.youtube || "#"} className="text-decoration-none">
                      <i className="fab fa-youtube fa-xl text-white"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Compact Footer */}
      <footer className="bg-light py-1 mt-auto">
        <div className="container text-center">
          <p className="mb-0 small text-muted">
            © Kementerian Kelautan dan Perikanan Republik Indonesia | {" "}
            <a href="http://kkp.go.id/unit-kerja/bkipm.html" rel="follow">
              Badan Mutu KKP
            </a>
            </p>
        </div>
      </footer>
    </div>
  );
};

export default Contact;